/**
 * Must match Table.css:$tableRowHeight
 */
export const TABLE_ROW_HEIGHT = 32;
export const TABLE_COLUMN_DEFAULT_WIDTH = 150;

// intent + collapsed input simple filter: 60px
// header cell padding: 2*12px
export const TABLE_COLUMN_MIN_WIDTH = 84;
export const TABLE_COLUMN_MIN_FILTERED_WIDTH = 144;
export const TABLE_COLUMN_MIN_FILTERED_WIDTH_SELECT = 159;
export const TABLE_CELL_PADDING_X = 12;

export const TABLE_CELL_BORDER_RIGHT_WIDTH = 0;
// Border width in pixels aroud the whole table; zero with current design, but keeping in code
// to keep all affected spots marked by the constants in case we return it.
export const TABLE_CONTENT_BORDER_WIDTH = 0;
// hide the right border of the last column
export const TABLE_RIGHT_HIDDEN_WIDTH = 1;
// hide the right border of the last column
export const TABLE_BOTTOM_HIDDEN_WIDTH = 1;
